import { styled } from '../../../../../core/theme/styled';

export const SecurityCaption = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SecurityText = styled.div`
  margin-top: ${(props) => props.theme.sizes.small};
  font-size: ${(props) => props.theme.sizes.small};
  text-align: center;
  color: ${(props) => props.theme.configuration.secondaryTextColor};
`;
